import { Follower } from "@scrile/api-provider/dist/api/FollowingsProvider";

export interface MassMessageUser {
  follower: Follower;
  subscriber: boolean;
}

export enum MessageSortTypeEnum {
  DEFAULT = 0,
  UNREAD = 1,
  UNREAD_OLDEST = 2,
  CUSTOM_REQUEST = 3,
}
